import { isAfter } from 'date-fns';
import type { PopulatedInteraction } from '@momentum/types';
import { InteractionType, FeedbackStatus } from '@momentum/types';

/**
 * Checks if an interaction was created after the last one-on-one meeting
 * @param interaction - The interaction to check
 * @param lastOneOnOneDate - The date of the last completed one-on-one meeting (ISO string or null)
 * @returns true if the interaction is new (created after last one-on-one)
 */
export function isNewInteraction(
  interaction: PopulatedInteraction,
  lastOneOnOneDate: string | null | undefined
): boolean {
  // If no last one-on-one date, consider nothing as new
  if (!lastOneOnOneDate) {
    return false;
  }

  const interactionDate = new Date(interaction.metadata.createdAt);
  const lastMeetingDate = new Date(lastOneOnOneDate);

  // Interaction is new if it was created after the last one-on-one
  return isAfter(interactionDate, lastMeetingDate);
}

/**
 * Checks if an interaction is an open blockage (unfinished feedback)
 * @param interaction - The interaction to check
 * @returns true if the interaction is a feedback with status !== FINISHED
 */
export function isOpenBlockage(interaction: PopulatedInteraction): boolean {
  if (interaction.type !== InteractionType.FEEDBACK) {
    return false;
  }

  // Check if status exists and is not FINISHED
  if ('status' in interaction) {
    return interaction.status !== FeedbackStatus.FINISHED;
  }

  return false;
}
